import './Loader.css';

const Loader = () => {
  return <span className="loader" />;
};

export default Loader;